import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';

var MAX_SCREENSHOTS = 5;
// 서버 multer 필터와 동일 값 (routes/bug-reports.js ALLOWED_MIMES / limits.fileSize).
// 여기서 걸러내지 않으면 거부된 1장 때문에 요청 전체가 실패해 나머지 사진까지 유실된다.
// bmp 는 OS/브라우저에 따라 image/x-ms-bmp · image/x-bmp 로도 오므로 셋 다 허용.
// (HEIC 는 제외 — 저장은 되지만 브라우저가 못 그려 신고함 미리보기가 깨진다. 서버 변환 선행 필요.)
var ALLOWED_MIMES = ['image/jpeg', 'image/png', 'image/webp',
  'image/gif', 'image/bmp', 'image/x-ms-bmp', 'image/x-bmp', 'image/tiff'];
var MAX_FILE_MB = 10;
var MAX_FILE_SIZE = MAX_FILE_MB * 1024 * 1024;
var OPEN_EVENT = 'autodex:bug-report';

// 화면에 떠 있는 BugReportButton 의 신고 창을 연다 — AI도우미 [문의 남기기] 가 'question'(분류 '질문' 선택)으로 쓴다 (Jin 10/22).
export function openBugReport(view) { window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: view || 'form' })); }

// 상단 바의 [🐛 오류 신고] [📋 내 신고] — 신고 창·목록은 화면에 하나뿐인 BugReportButton 이 연다.
// compact = 아이콘만 (모바일 얇은 바).
export function BugReportBarButtons({ compact }) {
  var fire = function(view) { window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: view })); };
  var btn = { border: '1px solid rgba(255,255,255,.3)', background: 'transparent', color: '#fff', fontSize: 12, padding: compact ? '3px 7px' : '4px 10px', borderRadius: 6, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 };
  return (
    <span className="bug-report-bar" style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
      <button type="button" onClick={function() { fire('form'); }} style={btn} title="오류 신고">{compact ? '🐛' : '🐛 오류 신고'}</button>
      <button type="button" onClick={function() { fire('list'); }} style={btn} title="내 신고 목록">{compact ? '📋' : '📋 내 신고'}</button>
    </span>
  );
}

function BugReportButton({ user, showToast }) {
  var [open, setOpen] = useState(false);
  var [listOpen, setListOpen] = useState(false);
  var [category, setCategory] = useState('bug');
  var [title, setTitle] = useState('');
  var [desc, setDesc] = useState('');
  var [screenshotFiles, setScreenshotFiles] = useState([]);
  var [screenshotPreviews, setScreenshotPreviews] = useState([]);
  var [sending, setSending] = useState(false);
  // 본문 저장은 끝났는데 사진 업로드만 실패한 신고 id — 재시도 시 이 id 로 사진만 다시 올린다.
  var [pendingReportId, setPendingReportId] = useState(null);
  var [reports, setReports] = useState([]);
  var [detailReport, setDetailReport] = useState(null);
  var [detailSsUrl, setDetailSsUrl] = useState('');
  var [detailGallery, setDetailGallery] = useState([]);
  var [lightbox, setLightbox] = useState('');
  var pasteRef = useRef(null);

  var currentPage = window.location.hash || window.location.pathname;

  var loadReports = function() {
    authFetch(API + '/bug-reports').then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) setReports(d.reports || []);
    }).catch(function() {});
  };

  useEffect(function() { loadReports(); }, []);

  // 상단 바 버튼(BugReportBarButtons)이 보내는 열기 신호 — 화면을 가리던 떠 있는 버튼 대신 (Jin 10/21).
  useEffect(function() {
    var onOpen = function(e) {
      if (e.detail === 'list') { setListOpen(function(v) { return !v; }); loadReports(); }
      else { if (e.detail === 'question') setCategory('question'); setOpen(true); }
    };
    window.addEventListener(OPEN_EVENT, onOpen);
    return function() { window.removeEventListener(OPEN_EVENT, onOpen); };
  }, []);

  // 부작용(토스트 / objectURL 생성 / 다른 state 갱신) 은 setState updater 밖에서 수행한다.
  // updater 안에서 하면 render 시점에 실행되어 미리보기 중복·objectURL 누수를 만든다 (#309 계열).
  var addFiles = function(filesToAdd) {
    if (!filesToAdd || filesToAdd.length === 0) return;
    var remaining = MAX_SCREENSHOTS - screenshotFiles.length;
    if (remaining <= 0) {
      showToast('최대 ' + MAX_SCREENSHOTS + '장까지 첨부 가능합니다', 'err');
      return;
    }
    // 형식·용량 검사 (서버 필터와 동일) — 거부된 파일만 제외하고 나머지는 살린다.
    var valid = [];
    var badType = 0, tooBig = 0;
    for (var i = 0; i < filesToAdd.length; i++) {
      var f = filesToAdd[i];
      if (ALLOWED_MIMES.indexOf(f.type) < 0) { badType++; continue; }
      if (f.size > MAX_FILE_SIZE) { tooBig++; continue; }
      valid.push(f);
    }
    var allowed = valid.slice(0, remaining);
    var skipped = [];
    if (badType > 0) skipped.push('이미지(jpeg/png/webp/gif/bmp/tiff)만 첨부 가능 — ' + badType + '장 제외됨');
    if (tooBig > 0) skipped.push('장당 ' + MAX_FILE_MB + 'MB 이하 — ' + tooBig + '장 제외됨');
    if (valid.length > remaining) skipped.push('최대 ' + MAX_SCREENSHOTS + '장 — ' + (valid.length - remaining) + '장 무시됨');
    if (skipped.length > 0) showToast(skipped.join(' / '), 'err');
    if (allowed.length === 0) return;
    var newPreviews = allowed.map(function(f) { return URL.createObjectURL(f); });
    setScreenshotFiles(function(prev) { return prev.concat(allowed); });
    setScreenshotPreviews(function(prev) { return prev.concat(newPreviews); });
  };

  var handlePaste = function(e) {
    var items = e.clipboardData && e.clipboardData.items;
    if (!items) return;
    var pasted = [];
    for (var i = 0; i < items.length; i++) {
      // 형식·용량 판정은 addFiles 한 곳에서만 — 여기서 image 접두사만 보면 heic 가 통과해 서버에서 터진다.
      var file = items[i].kind === 'file' ? items[i].getAsFile() : null;
      if (file) pasted.push(file);
    }
    if (pasted.length > 0) addFiles(pasted);
  };

  var handleFileSelect = function(e) {
    if (e.target.files && e.target.files.length > 0) {
      // FileList 는 live 객체 — e.target.value='' 로 비워지면 addFiles 의 setState updater
      // (render 시점 실행) 가 빈 목록을 보게 된다. 배열로 스냅샷 후 전달.
      var picked = Array.prototype.slice.call(e.target.files);
      addFiles(picked);
      e.target.value = '';
    }
  };

  var removeScreenshot = function(idx) {
    setScreenshotFiles(function(prev) {
      var next = prev.slice(); next.splice(idx, 1); return next;
    });
    setScreenshotPreviews(function(prev) {
      var next = prev.slice();
      try { URL.revokeObjectURL(next[idx]); } catch (e) {}
      next.splice(idx, 1);
      return next;
    });
  };

  // 413 등은 본문이 JSON 이 아닐 수 있다 — 파싱 실패해도 실패 분기로 흘린다.
  var parseJsonSafe = function(res) {
    return res.json().then(function(d) { return d; }, function() { return null; });
  };

  // 사진만 업로드 (신고 본문은 이미 저장된 상태). 실패 시 폼·첨부를 유지해 재시도 가능하게 둔다.
  var uploadScreenshots = function(reportId) {
    var count = screenshotFiles.length;
    var fd = new FormData();
    screenshotFiles.forEach(function(f) { fd.append('screenshots', f); });
    var failed = function(msg) {
      setSending(false);
      setPendingReportId(reportId);
      showToast(msg || '스크린샷 업로드 실패 — 다시 시도해주세요', 'err');
      loadReports();
    };
    authFetch(API + '/bug-reports/' + reportId + '/screenshots', { method: 'POST', body: fd })
      .then(parseJsonSafe)
      .then(function(uploadRes) {
        if (uploadRes && uploadRes.success) {
          setSending(false); resetForm(); showToast('신고 접수 완료 (' + count + '장)'); loadReports();
        } else {
          failed(uploadRes && uploadRes.error);
        }
      })
      .catch(function() { failed(''); });
  };

  var submit = function() {
    // 재시도 — 본문은 이미 저장됐으므로 사진만 다시 올린다 (POST /bug-reports 재호출 시 중복 신고).
    if (pendingReportId) { setSending(true); uploadScreenshots(pendingReportId); return; }
    if (!title.trim()) { showToast('제목을 입력해주세요', 'err'); return; }
    setSending(true);
    authFetch(API + '/bug-reports', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ category: category, title: title, description: desc, page: currentPage })
    }).then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) {
        var reportId = d.id;
        if (screenshotFiles.length > 0 && reportId) {
          uploadScreenshots(reportId);
        } else {
          setSending(false); resetForm(); showToast('신고 접수 완료'); loadReports();
        }
      } else { setSending(false); showToast(d.error || '신고 실패', 'err'); }
    }).catch(function() { setSending(false); showToast('서버 오류', 'err'); });
  };

  var resetForm = function() {
    setOpen(false); setCategory('bug'); setTitle(''); setDesc(''); setPendingReportId(null);
    screenshotPreviews.forEach(function(u) { try { URL.revokeObjectURL(u); } catch(e) {} });
    setScreenshotFiles([]); setScreenshotPreviews([]);
  };

  // 재시도를 포기하고 닫는 경우 — 신고는 남고 사진만 없는 상태임을 한 번 알린다.
  var closeForm = function() {
    if (pendingReportId) showToast('신고는 접수되었습니다 (사진 미첨부)');
    resetForm();
  };

  var openDetail = function(r) {
    setDetailReport(r);
    setDetailSsUrl('');
    setDetailGallery([]);
    if (r.screenshot) {
      authFetch(API + '/bug-reports/' + r.id + '/screenshot').then(function(res) { return res.blob(); }).then(function(blob) { setDetailSsUrl(URL.createObjectURL(blob)); }).catch(function() {});
    }
    if (r.screenshots && r.screenshots.length > 0) {
      var loaded = [];
      r.screenshots.forEach(function(s) {
        authFetch(API + '/bug-reports/' + r.id + '/screenshots/' + s.id).then(function(res) { return res.blob(); }).then(function(blob) {
          loaded.push({ id: s.id, url: URL.createObjectURL(blob), order_index: s.order_index });
          loaded.sort(function(a, b) { return a.order_index - b.order_index; });
          setDetailGallery(loaded.slice());
        }).catch(function() {});
      });
    }
  };

  var catKr = { bug: '버그', improvement: '개선요청', question: '질문' };
  var statusKr = { open: '접수', in_progress: '처리중', resolved: '해결', closed: '종료' };
  var statusColor = { open: '#3b82f6', in_progress: '#f59e0b', resolved: '#16a34a', closed: '#94a3b8' };

  return (
    <>
      {/* Report modal */}
      {open && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }} onClick={closeForm}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: 480, maxWidth: '94vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }} onClick={function(e) { e.stopPropagation(); }} onPaste={handlePaste} ref={pasteRef}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>오류/개선 신고</h3>
            <button onClick={closeForm} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#999' }}>✕</button>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>분류</label>
            <div style={{ display: 'flex', gap: 8 }}>
              {[['bug', '🐛 버그'], ['improvement', '💡 개선요청'], ['question', '❓ 질문']].map(function(c) {
                var isActive = category === c[0];
                return <button key={c[0]} onClick={function() { setCategory(c[0]); }} style={{ flex: 1, padding: '8px 0', borderRadius: 8, border: '2px solid ' + (isActive ? '#2563eb' : '#e5e7eb'), background: isActive ? '#eff6ff' : '#fff', color: isActive ? '#2563eb' : '#64748b', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{c[1]}</button>;
              })}
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>제목 <span style={{ color: '#dc2626' }}>*</span></label>
            <input value={title} onChange={function(e) { setTitle(e.target.value); }} placeholder="간단한 제목" style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #d0d5dd', fontSize: 14, outline: 'none' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>상세 설명</label>
            <textarea value={desc} onChange={function(e) { setDesc(e.target.value); }} placeholder="어떤 상황에서 어떤 문제가 발생했는지 설명해주세요" rows={4} style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #d0d5dd', fontSize: 13, outline: 'none', resize: 'vertical' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>스크린샷 <span style={{ color: '#94a3b8', fontWeight: 400 }}>(Ctrl+V 또는 파일 선택, 최대 {MAX_SCREENSHOTS}장)</span></label>
            {screenshotPreviews.length > 0 && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
              {screenshotPreviews.map(function(p, idx) {
                return <div key={idx} style={{ position: 'relative' }}>
                  <img src={p} alt={'shot-' + idx} style={{ width: 86, height: 86, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb' }} />
                  <button onClick={function() { removeScreenshot(idx); }} style={{ position: 'absolute', top: 2, right: 2, background: '#dc2626', color: '#fff', border: 'none', borderRadius: '50%', width: 20, height: 20, fontSize: 11, cursor: 'pointer' }}>✕</button>
                </div>;
              })}
            </div>}
            {screenshotFiles.length < MAX_SCREENSHOTS && <input type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/bmp,image/tiff" multiple onChange={handleFileSelect} style={{ fontSize: 12 }} />}
            {screenshotFiles.length > 0 && <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>{screenshotFiles.length} / {MAX_SCREENSHOTS} 장</div>}
          </div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 16 }}>현재 페이지: {currentPage}</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={closeForm} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13, color: '#555' }}>{pendingReportId ? '닫기' : '취소'}</button>
            <button onClick={submit} disabled={sending} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: sending ? '#aaa' : '#dc2626', color: '#fff', cursor: sending ? 'default' : 'pointer', fontSize: 13, fontWeight: 700 }}>{sending ? '전송 중...' : (pendingReportId ? '사진 다시 올리기' : '신고하기')}</button>
          </div>
        </div>
      </div>}

      {/* My reports list — 화면 가운데 큰 창 (Jin 10/21: 작은 팝업은 보기 어렵다) */}
      {listOpen && <div data-testid="bug-list-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9991 }} onClick={function() { setListOpen(false); }}>
      <div role="dialog" aria-label="내 신고 목록" style={{ width: 960, maxWidth: '94vw', height: '85vh', background: '#fff', borderRadius: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden', display: 'flex', flexDirection: 'column' }} onClick={function(e) { e.stopPropagation(); }}>
        <div style={{ padding: '16px 24px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <span style={{ fontWeight: 700, fontSize: 18 }}>내 신고 목록 ({reports.length})</span>
          <button onClick={function() { setListOpen(false); }} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#999' }}>✕</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {reports.length === 0 && <div style={{ padding: '60px 16px', textAlign: 'center', color: '#aaa', fontSize: 15 }}>신고 내역이 없습니다</div>}
          {reports.map(function(r) {
            var shotCount = (r.screenshots && r.screenshots.length) || (r.screenshot ? 1 : 0);
            return <div key={r.id} style={{ padding: '14px 24px', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }} onClick={function() { openDetail(r); }} onMouseEnter={function(e) { e.currentTarget.style.background = '#f8fafc'; }} onMouseLeave={function(e) { e.currentTarget.style.background = '#fff'; }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                  <span style={{ fontSize: 16 }}>{r.category === 'bug' ? '🐛' : r.category === 'improvement' ? '💡' : '❓'}</span>
                  <span style={{ fontSize: 15, fontWeight: 600, color: '#222' }}>{r.title}</span>
                  {shotCount > 0 && <span style={{ fontSize: 12, color: '#3b82f6' }}>📷 {shotCount}</span>}
                </div>
                <span style={{ fontSize: 13, fontWeight: 600, padding: '3px 10px', borderRadius: 6, flexShrink: 0, background: statusColor[r.status] || '#94a3b8', color: '#fff' }}>{statusKr[r.status] || r.status}</span>
              </div>
              <div style={{ fontSize: 13, color: '#94a3b8', marginTop: 4 }}>{(r.created_at || '').slice(0, 16)} · {catKr[r.category] || r.category}</div>
              {r.admin_reply && <div style={{ fontSize: 13, color: '#16a34a', marginTop: 4, fontWeight: 600 }}>💬 답변 있음</div>}
            </div>;
          })}
        </div>
      </div>
      </div>}

      {/* Detail modal */}
      {detailReport && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }} onClick={function() { setDetailReport(null); }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: 480, maxWidth: '94vw', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }} onClick={function(e) { e.stopPropagation(); }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 16 }}>{catKr[detailReport.category] || ''} — {detailReport.title}</h3>
            <button onClick={function() { setDetailReport(null); }} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#999' }}>✕</button>
          </div>
          <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>신고일: {(detailReport.created_at || '').slice(0, 16)} · 상태: <span style={{ fontWeight: 700, color: statusColor[detailReport.status] || '#94a3b8' }}>{statusKr[detailReport.status] || detailReport.status}</span></div>
          {detailReport.page && <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 8 }}>페이지: {detailReport.page}</div>}
          {detailReport.description && <div style={{ padding: '10px 12px', background: '#f8fafc', borderRadius: 8, fontSize: 13, color: '#333', marginBottom: 12, whiteSpace: 'pre-wrap' }}>{detailReport.description}</div>}
          {detailReport.screenshot && <div style={{ marginBottom: 12 }}>{detailSsUrl ? <img src={detailSsUrl} alt="screenshot" style={{ maxWidth: '100%', maxHeight: 250, borderRadius: 8, border: '1px solid #e5e7eb', cursor: 'zoom-in' }} onClick={function() { setLightbox(detailSsUrl); }} /> : <div style={{ padding: 12, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>스크린샷 로딩 중...</div>}</div>}
          {detailGallery.length > 0 && <div style={{ marginBottom: 12, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {detailGallery.map(function(g) {
              return <img key={g.id} src={g.url} alt={'shot-' + g.id} onClick={function() { setLightbox(g.url); }} style={{ width: 110, height: 110, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb', cursor: 'zoom-in' }} />;
            })}
          </div>}
          {detailReport.admin_reply ? <div style={{ padding: '10px 12px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#16a34a', marginBottom: 4 }}>관리자 답변</div>
            <div style={{ fontSize: 13, color: '#333', whiteSpace: 'pre-wrap' }}>{detailReport.admin_reply}</div>
            {detailReport.resolved_at && <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4 }}>처리일: {(detailReport.resolved_at || '').slice(0, 16)}</div>}
          </div> : <div style={{ fontSize: 12, color: '#94a3b8', fontStyle: 'italic' }}>아직 답변이 없습니다</div>}
        </div>
      </div>}

      {/* Lightbox */}
      {lightbox && <div onClick={function() { setLightbox(''); }} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out' }}>
        <img src={lightbox} alt="zoom" style={{ maxWidth: '94vw', maxHeight: '94vh', borderRadius: 8 }} />
      </div>}
    </>
  );
}

export default BugReportButton;
